const { default: styled } = require('styled-components');

export const Container = styled.div`
  border-radius: 4px;
  padding: 40px;
  margin-bottom: 20px;
  min-height: 100vh;
`;
